var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.141,
    height: 34.5,
    viewBox: "0 0 37.141 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-packages",
    transform: "translate(-239 -730)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(239 730)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trolley"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M36.925,22.516a1.571,1.571,0,0,0-2.01-.942L23.2,25.839a5.434,5.434,0,0,0-4.63-2.161L11.519,4.347A6.609,6.609,0,0,0,3.094.4l-2.1.76A1.571,1.571,0,1,0,2.063,4.108l2.073-.754A3.468,3.468,0,0,1,8.566,5.421L15.6,24.752a5.422,5.422,0,0,0,3.254,9.763,5.29,5.29,0,0,0,1.828-.333,5.428,5.428,0,0,0,3.562-5.39l11.742-4.285a1.571,1.571,0,0,0,.936-1.992ZM20.917,30.055a2.281,2.281,0,1,1,.075-1.74,2.281,2.281,0,0,1-.075,1.74Z",
    transform: "translate(0.128 -0.015)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M33.389,26.505a4.134,4.134,0,0,1-3.883-2.727l-2.651-7.231a4.14,4.14,0,0,1,2.513-5.3l6.911-2.532h0a4.146,4.146,0,0,1,5.3,2.475l2.632,7.231a4.14,4.14,0,0,1-2.475,5.3L34.79,26.235a4.278,4.278,0,0,1-1.4.27Z",
    transform: "translate(-9.813 -3.157)",
    fill: "#ffffff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPackages);
export default __webpack_public_path__ + "static/media/icon-packages.e75a958a3fd8b2a007e2f989a842e461.svg";
export { ForwardRef as ReactComponent };